/*
 * @file: index.js
 * @description: It Contain environment variables.
 * @date: 21.12.2021
 * @author: Nk
 */

//For local setup
const local = {
	apiUrl: "http://localhost:",
	PORT: '6163/api',
	socketUrl: 'http://localhost:7011',
	socketUrlBackend: 'http://localhost:6163',
	baseUrl: "http://localhost:3000",
	socketPath: ''
};

//For staging server
const staging1 = {
	apiUrl: "http://20.25.118.115:",
	PORT: '3000/api',
	socketUrl: 'http://20.25.118.115:7011',
	socketUrlBackend: 'http://20.25.118.115:3000',
	baseUrl: "http://20.25.118.115:4200",
	socketPath: ''
	
};

const staging = {
	apiUrl: "https://dev1.mortgageautomation.com/",
	PORT: 'api',
	socketUrl: 'https://dev1.mortgageautomation.com/socket',
	socketUrlBackend: 'https://dev1.mortgageautomation.com',
	baseUrl: "https://dev1.mortgageautomation.com",
	socketPath: '/socket.io'
	
};


//For production server port KEY can not be remove its using in application
const production = {
	apiUrl: "https://mortgageautomation.com/",
	PORT: 'api',
	socketUrl: 'https://mortgageautomation.com',
	socketUrlBackend: 'https://mortgageautomation.com',
	baseUrl: "https://mortgageautomation.com",
	socketPath: '/myapp/socket.io'
};

const recovery = {
	apiUrl: "http://40.76.227.108:",
	PORT: '3000/api',
	socketUrl: 'http://40.76.227.108:7011',
	socketUrlBackend: 'http://40.76.227.108:3000',
	baseUrl: "http://20.25.118.115:4200",
	socketPath: ''
	
};

// console.log("process.env.REACT_APP_ENV :", process.env.REACT_APP_ENV);

if (process.env.REACT_APP_ENV === "local") module.exports = local;
else if (process.env.REACT_APP_ENV === "staging") module.exports = staging;
else if (process.env.REACT_APP_ENV === "production") module.exports = production;
else if (process.env.REACT_APP_ENV === "recovery") module.exports = recovery;
else module.exports = staging;
